import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { TokenService } from './token.service';

@Injectable({
  providedIn: 'root'
})
export class ProductService {
  private apiUrl = environment.API_URL + 'internal/';

  constructor(
    private httpClient: HttpClient,
    private tokenService: TokenService
  ) {}

  private getCustomerHeader(): HttpHeaders {
    return new HttpHeaders({
      'Content-Type': 'application/json',
      'Authorization': 'Bearer ' + this.tokenService.getComponentCodeToken(),
      'Accept-Language': 'pt-BR'
    });
  }

  /**
   * Busca itens de lote por código de barras e local.
   */
  public searchBatchItem(
    branchCode: number,
    locationCode: string,
    batchItemBarCode:string | undefined
  ): Observable<any> {
    const url = this.apiUrl + 'product/v2/batch-item/search';

    const body = {
      branchCode,
      locationCode,
      batchItemBarCode,
      page: 1,
      pageSize: 100
    };

    return this.httpClient.post<any>(url, body, {
      headers: this.getCustomerHeader()
    });
  }

  /**
   * Busca detalhes do lote por branch e código de lote.
   */
  public searchBatchByCode(
    branchCode: number,
    batchCode: number
  ): Observable<any> {
    const url = this.apiUrl + 'product/v2/batch-item/search';

    const body = {
      branchCode,
      batchCode,
      sequence: 0,
      batchItemBarCode: '',
      locationCode: '',
      page: 1,
      pageSize: 100
    };

    return this.httpClient.post<any>(url, body, {
      headers: this.getCustomerHeader()
    });
  }

  /**
   * Atualiza informações do item de lote.
   */
  public updateBatchInfo(batchItems: any[]): Observable<any> {
    const url = this.apiUrl + 'product/v2/batch-info';

    const body = { batchItems };

    return this.httpClient.put<any>(url, body, {
      headers: this.getCustomerHeader()
    });
  }

  public searchBatchLocation(locationCode: string): Observable<any> {
  const url = this.apiUrl + 'product/v2/batch-location';

  const body = {
    locationCodeList: [locationCode],
    page: 1,
    pageSize: 100
  };

  const headers = this.getCustomerHeader();

  return this.httpClient.post<any>(url, body, { headers });
}

}
